import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67b130da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "input" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "input" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "submit" }

import api from '@/api/userApi';
import devices from '@/store/device';
import user, { State } from '@/store/user';
import { computed, onMounted, reactive } from 'vue';
import { useStore } from 'vuex';
import { version, app, device } from '@/config'
import i18, { State as I18State } from '@/store/i18';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[user.name])

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].mineText)

const state = reactive({
    content: '',
    contact: '',
})

onMounted(autoFill)

function autoFill() {
    if (data.value.info) {
        state.contact = data.value.info.mobile || data.value.info.email
    }
    state.content = ''
}

async function onSubmit() {
    let content = state.content.trim()
    if (!content) {
        return devices.toast(store, lang.value.contentError)
    }
    if (!/^\d+$/.test(state.contact) &&
        !/^([a-zA-Z0-9]+[_|_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,6}$/.test(state.contact)) {
        return devices.toast(store, lang.value.contactError)
    }
    try {
        let body = {
            content: state.content,
            contact: state.contact,
            version,
            device,
            app,
            ua: window.navigator.userAgent,
        }
        await api.postSuggest(body)
        devices.toast(store, lang.value.successSubmit)
        state.content = ''
    } catch (e) {
        devices.toast(store, lang.value.errorSubmit)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).content) = $event)),
        placeholder: _unref(lang).contentPlaceHolder
      }, null, 8, _hoisted_3), [
        [_vModelText, _unref(state).content]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).contact) = $event)),
        placeholder: _unref(lang).contactPlaceHolder
      }, null, 8, _hoisted_5), [
        [_vModelText, _unref(state).contact]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("a", {
        class: "btn red",
        onClick: onSubmit
      }, _toDisplayString(_unref(lang).submit), 1)
    ])
  ]))
}
}

})